import { gql } from '@zenbusiness/application-commons-graphql';

export const GET_LIST_CHECK_DEPOSIT_QUERY = gql`
  query checkDeposits($params: CheckDepositsInput!) {
    checkDeposits(params: $params) {
      checkDeposits {
        id
        type
        depositTo
        status
        summary
        amount {
          amount
          currency
          formattedAmount
        }
        createdAt
        estimatedCompletionDate
        transactionId
        reason
        method
      }
      pagination {
        limit
        offset
        next
        total
      }
    }
  }
`;

export const GET_CHECK_DEPOSIT_FOR_RESUBMIT = gql`
  query checkDeposit($params: CheckDepositInput!) {
    checkDeposit(params: $params) {
      reason
      status
      idempotencyKey
      amount {
        amount
      }
    }
  }
`;
